import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'
import PageTracker from '../../../../common/PageTrackerHelper'

export default {
  name: 'ScantallyDownloadreport',
  components: {
      VueElementLoading,
      Paginate,
  },
  mixins:[PageTracker],
  data: function() {
      return {
        picked : '0',
        FromDate : '',
        toDate : '',
        reportData : [],
        isloading:false,
        userDataKey : '',
      }
  },
  created: function() {

  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);

    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.rolename = userdetail.userrole[0]['rolename'];
    this.hubdetails = userdetail.hubdetails[0];

    //console.log('Mixin is working for :',result);
  },
  methods : {
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.isloading = true;
          var date1 = new Date(this.FromDate);
          var date2 = new Date(this.toDate);
          var diffDays = parseInt((date2 - date1) / (1000 * 60 * 60 * 24));


          if(diffDays <= 7 && date2 >= date1){
            axios.post(apiUrl.api_url_for_scantally + 'files/getFileNames', {
              "fromDate" : this.FromDate,
              "toDate" : this.toDate,
              "folderPrefix" : this.picked
            })
              .then((response) => {
                  if(response.data.code===200){
                      this.isloading = false;
                      this.reportData = response.data.data;
                  }
                  else {
                      this.isloading = false;
                      this.reportData=[];
                      this.$alertify.error(response.data.message);
                  }
              })
              .catch((httpException) => {
                  this.isloading = false
                  this.$alertify.error("No Records Found");
                  console.error('exception is:::::::::', httpException)
              })
          }
          else {
            this.$alertify.error("Please select To date greter than From date and date difference not more than 7 days");
          }


        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    downloadFile(filePath){
        axios.post(apiUrl.api_url_for_scantally + 'getSignedUrl', {
          "path" : filePath.path
        })
        .then((response) => {
            if(response.data.code===200){
              var link = document.createElement('a');
              link.href = response.data.data;
              link.setAttribute('target','_blank');
              window.open(response.data.data, '_blank');
              return true;
            }
            else {
                this.reportData=[];
                this.$alertify.error(response.data.message);
            }
        })
        .catch((httpException) => {
            this.$alertify.error("No Records Found");
            console.error('exception is:::::::::', httpException)
        })
    },
    clear(){
      this.picked = '0',
      this.FromDate = '';
      this.toDate = '';
      this.reportData = [];

      this.$validator.reset();
      this.errors.clear();
      this.isloading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ScanTally/ScantallyDownloadreport/ScantallyDownloadreport.component.js